/*
 * @Description: 推荐单
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-01-06 15:37:26
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-11 16:50:57
 */
import request from "../../utils/request";
import server from "./config";
export default {
    /**
     * 上海医生提交
     */
    createBaseInfo: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/1/createBaseInfo`,
            method: "post",
            data
        });
    },

    /**
     * 上海医生详情
     */
    showDetailInfo: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/1/showDetailInfo`,
            method: "post",
            data
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/modules/shDoctor.js